import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "@lingui/macro";
import { Button } from "@material-ui/core";
import { goToBeginning } from "../utils/scenario-manager";
// import * as ReactGA from "react-ga";
import { switchWidgetPatientArea } from "../utils/fetcher";
import SummaryTeleconsultation from "./SummaryTeleconsultation";
import SummaryNormal from "./SummaryNormal";
import { notificationAppointment } from "../utils/fetcher";

class SummaryReport extends Component {
  state = {
    checkedNotification: false,
    notificationData: undefined
  };

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
  }

  print = e => {
    e.preventDefault();
    // ReactGA.event({
    //   category: "Impression",
    //   action: "Impression",
    //   label: "Impression de récapitulatif"
    // });
    window.print();
  };

  getData = () => {
    const dataKey = this.props.step.data.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      return this.props.dataSource[dataKey];
    }
    return null;
  };

  handleChange = notifState => {
    this.setState({ checkedNotification: notifState });
  };

  setNotificationData = (isSet, data) => {
    this.setState({ checkedNotification: isSet, notificationData: data });
  };

  handleSubmit = () => {
    if (this.state.checkedNotification && this.state.notificationData) {
      this.props.notificationAppointment(this.state.notificationData);
    }

    if (this.props.firstConnexionPatientArea) {
      this.props.switchWidgetPatientArea();
    } else {
      this.props.goToBeginning();
    }
  };

  render() {
    let data = this.getData();
    data = data && data[0];
    return (
      <React.Fragment>
        {data && (
          <div className="summary">
            {this.props.typeConsultation === "teleconsult" ? (
              <SummaryTeleconsultation
                data={data}
                setNotificationData={this.setNotificationData}
                setNotifState={this.handleChange}
              />
            ) : (
              <SummaryNormal
                data={data}
                setNotificationData={this.setNotificationData}
                setNotifState={this.handleChange}
              />
            )}

            <div className="bottom">
              <div className="display-flex justify-content-right wrap-btn-summary">
                <Button
                  color="secondary"
                  variant="contained"
                  className="btn"
                  onClick={this.print}
                >
                  <i className="material-icons">print</i>
                  <Trans id="imprimer" />
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className="ml-10 finish"
                  onClick={this.handleSubmit}
                >
                  <Trans id="W_STEP_BOUTON_TERMINER" />
                </Button>
              </div>
            </div>
            {data.identification_rdv && (
              <input
                id="identifiant_rdv_borne"
                type="hidden"
                value={data.identification_rdv}
              />
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

SummaryReport.propTypes = {
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  firstConnexionPatientArea: PropTypes.any,
  goToBeginning: PropTypes.func,
  notificationAppointment: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      keyValue: PropTypes.any
    })
  }),
  switchWidgetPatientArea: PropTypes.func,
  typeConsultation: PropTypes.string
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    firstConnexionPatientArea: state.firstConnexionPatientArea,
    typeConsultation: state.returnedValue.typeConsultation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    goToBeginning: () => dispatch(goToBeginning()),
    switchWidgetPatientArea: () => dispatch(switchWidgetPatientArea()),
    notificationAppointment: dataForm =>
      dispatch(notificationAppointment(dataForm))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryReport);
